/**
 * Sample data for 'Apex Precision (Navy & Steel)' template.
 * High-contrast, precision tooling and manufacturing aesthetic.
 */

export const apexPrecisionSample = {
  company: {
    id: "sample-apex-precision",
    name: "Apex Precision Tools & Engineering",
    tagline: "Carbide Cutting Tools, Industrial Identification & Custom Insulator Parts",
    headline: "Precision Tools. Permanent Marking. Engineered Parts.",
    description: "Apex Precision delivers high-performance carbide cutting tools, laser-marked and UV-printed industrial nameplates, electrical insulator components, and precision CNC job-work engineered to your exact specifications.",
    location: "Peenya Industrial Area, Bengaluru, Karnataka",
    city: "Bengaluru",
    state: "Karnataka",
    address: "Plot 166, 11th Cross, Peenya Industrial Area, Bengaluru, Karnataka - 560058",
    logo_url: "/template_assets/apex_precision/mark.png",
    cover_url: "/template_assets/apex_precision/showcase.jpg",
    category: "Precision Tooling & Job Work",
    mobile: "+91 80508 69773",
    whatsapp: "+91 80508 69773",
    email: "sales@apexprecision.in",
    website: "https://apexprecision.indianindustrialplatform.com",
    gst: "29AABCU9603R1ZM",
    year_established: 2014,
    delivery_area: "Pan-India & Global Export",
    certifications: [
      { name: "ISO 9001:2015", description: "Quality Management Systems certified for precision manufacturing." },
      { name: "ZED Certified", description: "Zero Defect Zero Effect certified industrial manufacturer." }
    ],
    catalog_heading: "Industrial Tooling & Parts Catalog"
  },
  products: [
    {
      id: "prod-apex-1",
      name: "Custom Solid Carbide End Mills",
      category: "Carbide Tools",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/4f33b6e35a2eaf302d8f59fd6751f63a18a52456932e38948874290c98dfeff2.jpeg",
      price: "₹3,200",
      moq: "10 Pieces",
      description: "Special multi-flute solid carbide end mills with AlTiN coating for high-speed machining of hardened alloys and stainless steel."
    },
    {
      id: "prod-apex-2",
      name: "Custom Step & Form Drills",
      category: "Carbide Tools",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/672dd3bd694cacb93f240892b227f6cbf8c048e368c3b2b509cc1c31d42e06ec.jpeg",
      price: "₹4,800",
      moq: "5 Pieces",
      description: "Multi-diameter step drills and custom profile form tools engineered to customer CAD drawings for combined drilling and chamfering."
    },
    {
      id: "prod-apex-3",
      name: "Laser-Marked Asset Nameplates",
      category: "Industrial Nameplates",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/43a7e6663d59ab4680a39e14feccaccca54b4cb0ceae649a7cf4ebc73fd8a3de.jpeg",
      price: "₹120",
      moq: "100 Units",
      description: "Permanent high-contrast laser marking on anodized aluminium and SS304. Impervious to heat, oils, abrasion, and outdoor exposure."
    },
    {
      id: "prod-apex-4",
      name: "UV-Printed Equipment Rating Plates",
      category: "Industrial Nameplates",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/9b31f91cfef2db993582a37b7e57eb03354b279eee7764a93a9d3674dcd3912d.jpeg",
      price: "₹175",
      moq: "50 Units",
      description: "Full-colour industrial UV printing on acrylic and brushed aluminium with white-ink backing and QR traceability codes."
    },
    {
      id: "prod-apex-5",
      name: "High-Voltage Electrical Insulators",
      category: "Insulator Components",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/7320c6243c4231e1408a83833a3d3ea554b20d58dcf192f4a6ae0604b49b0858.jpeg",
      price: "₹850",
      moq: "25 Units",
      description: "Heavy-duty electrical insulators engineered for switchgear, distribution panels, and high dielectric resistance."
    },
    {
      id: "prod-apex-6",
      name: "CNC Machined Insulator Spacers",
      category: "Insulator Components",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/e218f45e3c705dc3373cb25cbf0fde7c7211371bdc9d09be70a8ee2463c0492c.jpeg",
      price: "₹620",
      moq: "50 Units",
      description: "Precision-machined phenolic and epoxy-glass insulating components with drilled holes, threaded inserts, and milled slots."
    }
  ],
  services: [
    {
      id: "srv-apex-1",
      code: "S/01",
      name: "Precision Laser Marking & Engraving",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/81bf597b606198466cb69d2668158019225e704851212a25e2f3cff1c1e91c48.jpeg",
      description: "Laser marking and deep engraving job-work for nameplates, tooling, medical parts, and components with serial numbers, barcodes, and logos."
    },
    {
      id: "srv-apex-2",
      code: "S/02",
      name: "CNC Machining Job Work (Desktop & VMC)",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/9e6d388667022fa614b889c2df6616562faaaa45d1eeeb5b79e45794970f2d3f.jpeg",
      description: "Desktop VMC precision machining job work for small batch components, prototypes, fixtures, and custom insulator assemblies."
    },
    {
      id: "srv-apex-3",
      code: "S/03",
      name: "Industrial 3D Additive Prototyping",
      image_url: "https://static.prod-images.emergentagent.com/jobs/96a2efa0-0eaa-4f41-bbb2-7b99710e3c34/images/2d5d2dc015e9862afea2399db22e44b20e57f8b068c0d65cdb6b53dcc556e08a.jpeg",
      description: "Rapid 3D additive manufacturing for prototypes, fit-check models, concept validation, and custom jigs directly from CAD."
    }
  ],
  steps: [
    { num: "01", title: "Share Requirement", desc: "Send drawings, CAD files, samples or technical parameters." },
    { num: "02", title: "Technical Review", desc: "Our engineering team reviews specifications, materials and tolerances." },
    { num: "03", title: "Quotation & Timeline", desc: "You receive a clear commercial quotation with confirmed delivery dates." },
    { num: "04", title: "Production & Delivery", desc: "Your order is manufactured, 100% inspected, and securely dispatched." }
  ],
  posts: [],
  reels: []
};
